// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1oPo1","list":"PatternAutocomplete_list__3X58g"};